module.exports = "<div class=\"service-outer divider-group dg-lg\"> <div class=q-pad-horz-xs> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=q-boldest> Service: </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=service-name> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=q-boldest> Estimated Cost: </div> </div> <div class=\"col-md-2 col-xs-12\"> <div class=service-currency-total> </div> </div> <div class=\"col-md-1 col-xs-12\"> <a href=# class=service-remove-btn> <i class=\"fa fa-close fa-lg\"></i> </a> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/ServicesTab/html/serviceView.html
// module id = 1222
// module chunks = 1